// extracted by mini-css-extract-plugin
module.exports = {"alliancePopup":"pndK7","inner":"BscwV","innerContent":"xROwG","innerData":"QCYAN","data":"R_2h1","content":"UOePa","partyHeader":"hgwNU","total":"dTysl","closeBtn":"dZT6k"};